import React from 'react';

import { type EmojiCategory } from '@pkg/hooks';
import { getTypedObjectKeys } from '@pkg/types';

import { useCategoryContent } from './useCategoryContent';

import { Action, IconWrapper, Item, List, StyledNavigation } from './styles';

export interface NavigationProps {
    currentCategory: EmojiCategory;
    disabled?: boolean;
    onChange(category: EmojiCategory): void;
}

export function Navigation({ currentCategory, disabled = false, onChange }: NavigationProps) {
    const content = useCategoryContent();
    const keys = getTypedObjectKeys(content);

    const items = keys.map((key) => {
        const title = content[key].title;
        const ariaLabel = content[key].ariaLabel;
        const Icon = content[key].icon;

        const pressed = key === currentCategory && !disabled;
        const handleChange = () => onChange(key);

        // `aria-pressed` is intentionally `undefined` when "falsey".
        return (
            <Item key={`EmojiPicker-Navigation-Item-${title}`}>
                <Action
                    aria-label={ariaLabel}
                    aria-pressed={pressed ? true : undefined}
                    disabled={disabled}
                    onClick={handleChange}
                >
                    <IconWrapper>
                        <Icon />
                    </IconWrapper>
                </Action>
            </Item>
        );
    });

    return (
        <StyledNavigation>
            <List>{items}</List>
        </StyledNavigation>
    );
}
